import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { apiLogin, errMsg } from "../adminApi";
import { useAdminAuth } from "../AdminAuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await apiLogin(email.trim(), password);
      setUser(user);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-4">
      <div className="w-full max-w-sm">
        <div className="mb-6">
          <span className="font-display text-2xl font-extrabold tracking-tight text-chalk">RINOVA</span>
          <span className="ml-2 text-sm font-medium text-steel">Admin</span>
        </div>
        <Card className="border-line bg-surface2">
          <CardHeader>
            <CardTitle className="font-display text-xl">Accedi</CardTitle>
            <CardDescription>Area riservata alla gestione del catalogo.</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="flex flex-col gap-4">
              <div className="flex flex-col gap-1.5">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  autoComplete="username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="admin-login-email-input"
                />
              </div>
              <div className="flex flex-col gap-1.5">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="admin-login-password-input"
                />
              </div>
              {error && (
                <p className="text-sm text-destructive" data-testid="admin-login-error-text">
                  {error}
                </p>
              )}
              <Button type="submit" variant="lime" disabled={loading} data-testid="admin-login-submit-button">
                {loading && <Loader2 className="h-4 w-4 animate-spin" />}
                Accedi
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
